import React, { useContext, useState, useRef, useEffect } from 'react';

import { toast } from "react-toastify";

import Card from '../../shared/components/UIElements/Card';
import Button from '../../shared/components/FormElements/Button';

import Modal from '../../shared/components/UIElements/Modal';

import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { useHttpClient } from '../../shared/hooks/http-hook';

import { AuthContext } from '../../shared/context/auth-context';
import './FileItem.css';
// import footer
import Footer from '../../shared/components/UIElements/Footer';

const getFileMeta = mime => {
  // Images handled separately
  if (mime === 'application/pdf') {
    return { icon: '📕', bg: '#e53935', label: 'PDF' };
  }

  if (mime.includes('word')) {
    return { icon: '📘', bg: '#1e88e5', label: 'DOC' };
  }

  if (mime.includes('excel')) {
    return { icon: '📗', bg: '#2e7d32', label: 'XLS' };
  }

  if (mime.startsWith('audio/')) {
    return { icon: '🎵', bg: '#8e24aa', label: 'AUDIO' };
  }

  if (mime.startsWith('video/')) {
    return { icon: '🎬', bg: '#5e35b1', label: 'VIDEO' };
  }

  if (mime === 'text/plain') {
    return { icon: '📄', bg: '#616161', label: 'TXT' };
  }

  return { icon: '📁', bg: '#757575', label: 'FILE' };
};

const FileItem = props => {
    const { isLoading, error, sendRequest, clearError } = useHttpClient();
    const auth = useContext(AuthContext);
    const [showMenu, setShowMenu] = useState(false);

    const [showConfirmModal, setShowConfirmModal] = useState(false);


    const showDeleteWarningHandler = () => {
        setShowConfirmModal(true);
    };

    const cancelDeleteHandler = () => {
        setShowConfirmModal(false);
    };

    const confirmDeleteHandler = async () => {
        setShowConfirmModal(false);
        try {
            const responseData = await sendRequest(
                process.env.REACT_APP_BACKEND_URL + `/files/${props.id}`,
                'DELETE',
                null,
                {
                    Authorization: 'Bearer ' + auth.token
                }
            );
            console.log(responseData); 
            //props.onDelete(props.id);
            if (!error) {
                props.onDelete(props.id);
                toast.success("File deleted successfully!");
            }
        } catch (err) {
            toast.error(err.message || "File deletion failed.");
        }
    };

    const copyFileHandler = async () => {
        //event.preventDefault();

        try {
            const responseData = await sendRequest(
                process.env.REACT_APP_BACKEND_URL + `/files/${props.id}`,
                'POST',
                null,
                /*
                JSON.stringify({
                    //userId: auth.userId,
                    sourceFolder: "uploads",
                    destinationFolder: "uploads/shared"
                }),
                */
                {
                    /*'Content-Type': 'application/json',*/
                    Authorization: 'Bearer ' + auth.token
                }
            );
            //console.log(responseData);
            //console.log(responseData.success);
            if (responseData.success) {
                //alert("files copied successfully and added to shared files.");
                toast.success("File copied to shared");
            } else {
                //alert("copy failed");
                toast.error("Copy failed.");
            }
        } catch (err) {
            toast.error(err.message || "Copy failed.");
        }

    };

    const menuRef = useRef();

    // Close menu on outside click and auto-closing on scroll
    useEffect(() => {
        const handleClickOutside = event => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setShowMenu(false);
            }
        };

        const handleScroll = () => {
            setShowMenu(false);
        };

        document.addEventListener('mousedown', handleClickOutside);
        window.addEventListener('scroll', handleScroll, true);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, []);


    const closeMenu = () => setShowMenu(false);

    return (
        <React.Fragment>
            <ErrorModal error={error} onClear={clearError} />
            <Modal
                show={showConfirmModal}
                onCancel={cancelDeleteHandler}
                header="Are you sure?"
                footerClass="place-item__modal-actions"
                footer={
                    <React.Fragment>
                        <Button inverse onClick={cancelDeleteHandler}>
                            CANCEL
                        </Button>
                        <Button danger onClick={confirmDeleteHandler}>
                            DELETE
                        </Button>
                    </React.Fragment>
                }
            >
                <p>
                    Do you want to proceed and delete this file? Please note that it
                    can't be undone thereafter.
                </p>
            </Modal>
            <li className="place-item">
                <Card className="place-item__content">
                    {isLoading && <LoadingSpinner asOverlay />}
                    <div className="place-item__image-wrapper" ref={menuRef}>
                        <a
                            /*href={`${process.env.REACT_APP_ASSET_URL}/${props.image}`} Disabling this coz using cloudinary and using the following code href={props.image} below to fetch files from the cloudinary. */
                            href={props.image}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="file-card-link"
                        >
                            {props.mimeType.startsWith('image/') ? (
                                <img
                                    /*src={`${process.env.REACT_APP_ASSET_URL}/${props.image}`}  Disabling this coz using cloudinary and using the following code href={props.image} below to fetch files from the cloudinary.*/
                                    src={props.image}
                                    alt={props.originalName}
                                />
                            ) : (
                                <div
                                    className="file-preview file-icon-preview"
                                    style={{ backgroundColor: getFileMeta(props.mimeType).bg }}
                                >
                                    <div className="file-icon">
                                        {getFileMeta(props.mimeType).icon}
                                    </div>
                                    <div className="file-label">
                                        {getFileMeta(props.mimeType).label}
                                    </div>
                                </div>
                            )}
                        </a>

                        {auth.isLoggedIn && (
                            <button
                                className="place-item__menu-btn"
                                onClick={e => {
                                    e.preventDefault();   // 👈 stop link click
                                    e.stopPropagation();
                                    setShowMenu(prev => !prev);
                                }}
                            >
                                ⋮
                            </button>
                        )}

                        {auth.isLoggedIn && showMenu && (
                            <div className="place-item__menu">
                                {/*<Button to={`/files/${props.id}`} onClick={closeMenu}>Copy to Shared</Button>*/}
                                {auth.userId === props.creatorId && (
                                    <Button onClick={() => { copyFileHandler(); closeMenu(); }}>Copy to Shared</Button>
                                )}
                                {/*<Button danger onClick={closeMenu}>DELETE</Button>*/}
                                {auth.userId === props.creatorId && (
                                    <Button danger onClick={() => { showDeleteWarningHandler(); closeMenu(); }}>DELETE</Button>
                                )}
                            </div>
                        )}
                    </div>
                    {/* FILE NAME BELOW CARD */}
                    <p className="file-name-below" >
                        <a
                            /*href={`${process.env.REACT_APP_ASSET_URL}/${props.image}`}  Disabling this coz using cloudinary and using the following code href={props.image} below to fetch files from the cloudinary.*/
                            href={props.image}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {props.originalName}
                        </a>
                    </p>
                </Card>
            </li>
            {/* Footer */}
            <Footer />
        </React.Fragment>
    );
};

export default FileItem;
